import * as React from "react";
import { Input, Button } from "antd";
import { MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { IPasswordResetCredentials } from "../../../model/authentication/PasswordResetCredentials";
import ErrorMessage from "../ErrorMessage";

const PasswordResetForm = ({
  translate,
  credentials,
  setCredentialsValue,
  resetPassword,
  resetPasswordDisabled = false,
  loading,
  validationErrors
}: {
  translate: any;
  credentials: IPasswordResetCredentials;
  setCredentialsValue: (name: string, value: string) => void;
  resetPassword: () => Promise<void>;
  resetPasswordDisabled?: boolean;
  loading: boolean;
  validationErrors?: any;
}) => {
  const fieldStyle = { marginTop: 15, marginBottom: 15 };
  return (
    <React.Fragment>
      <div style={fieldStyle}>
        <Input
          prefix={<UserOutlined />}
          placeholder={translate("password_reset.username")}
          allowClear={true}
          value={credentials.username}
          onChange={(e) => setCredentialsValue("username", e.target.value)}
          autoFocus={true}
        />
        {validationErrors && validationErrors["username"] ? (
          <ErrorMessage errors={validationErrors["username"]} />
        ) : null}
      </div>
      <div style={fieldStyle}>
        <Input
          prefix={<MailOutlined />}
          placeholder={translate("password_reset.email")}
          allowClear={true}
          value={credentials.email}
          onChange={(e) => setCredentialsValue("email", e.target.value)}
        />
        {validationErrors && validationErrors["email"] ? (
          <ErrorMessage errors={validationErrors["email"]} />
        ) : null}
      </div>
      <div style={fieldStyle}>
        <Input
          prefix={<PhoneOutlined />}
          placeholder={translate("password_reset.phone")}
          allowClear={true}
          value={credentials.phone}
          onChange={(e) => setCredentialsValue("phone", e.target.value)}
        />
        {validationErrors && validationErrors["phone"] ? (
          <ErrorMessage errors={validationErrors["phone"]} />
        ) : null}
      </div>

      <div
        style={{
          marginTop: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
        <Button
          className="button-primary"
          key="submit"
          onClick={resetPassword}
          disabled={resetPasswordDisabled}
          loading={loading}>
          {translate("password_reset.submit_button")}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default PasswordResetForm;
